// extracted by mini-css-extract-plugin
export default {"card":"ProjectDevelopScopePage_card__IUMW7"};